module.exports = __webpack_public_path__ + "static/enchanted-cover-1-6fac1e5abff97eb42f32f7df42bfb989.mp4";